import { useMemo } from 'react'
import { DateTime } from 'luxon'

import { makePublicUrl } from 'app/utils/publicUrl'
import { SubscriptionInfo } from 'features/home/types'
import { isExpiringSoon } from 'features/home/components/HomeSubscription/utils'

import { PlanIcon, StyledPlanIcon } from './styles'
import { mdiWifi } from '@mdi/js'
import theme from 'theme_'

interface SubscriptionIconProps {
  subscriptionInfo: SubscriptionInfo | null
  size?: number
}

interface SubscriptionHistoryPlanIconProps {
  status: string | undefined
  planName?: string
  size?: number
}

function SubscriptionIcon({ subscriptionInfo, size }: SubscriptionIconProps) {
  const expiryHasWarn = useMemo(() => {
    return isExpiringSoon(subscriptionInfo, DateTime.now())
  }, [subscriptionInfo])

  switch (subscriptionInfo?.category) {
    case 'ESSENTIALS':
      return (
        <PlanIcon
          size={size}
          src={
            expiryHasWarn
              ? makePublicUrl('images/subscription/essential-plan-expiring.svg')
              : makePublicUrl('images/subscription/essential-plan.svg')
          }
          title={
            expiryHasWarn ? 'Savant Essentials Expiring' : 'Savant Essentials'
          }
        />
      )
    case 'NETWORK':
      return (
        <StyledPlanIcon
          size={size}
          path={mdiWifi}
          color={expiryHasWarn ? theme.colors.lightRed : theme.colors.green}
          title={expiryHasWarn ? 'Smart Network Expiring' : 'Smart Network'}
        />
      )
    default:
      return (
        <PlanIcon
          size={size}
          src={makePublicUrl('images/subscription/no-plan.svg')}
          title={'None'}
        />
      )
  }
}

export const SubscriptionHistoryPlanIcon = ({
  status,
  planName,
  size,
}: SubscriptionHistoryPlanIconProps) => {
  switch (status) {
    case 'subscribed':
    case 'renewed':
    case 'resubscribed':
    case 'upgraded':
      return (
        <PlanIcon
          size={size}
          src={
            planName?.indexOf('Network') !== -1
              ? makePublicUrl('images/subscription/network-plan.svg')
              : makePublicUrl('images/subscription/essential-plan.svg')
          }
        />
      )
    case 'cancelled':
    case 'renewal failed':
      return (
        <PlanIcon
          size={size}
          src={makePublicUrl('images/subscription/essential-plan-expiring.svg')}
        />
      )
    default:
      return (
        <PlanIcon
          size={size}
          src={makePublicUrl('images/subscription/no-plan.svg')}
        />
      )
  }
}

export default SubscriptionIcon
